import { OneMutationService, OneMutationServiceMutator } from 'types/services/services';
import { oneApi } from 'utils/api/api-fetcher';

const SERVICE_ID = 'login';

const logoutMutator: OneMutationServiceMutator<null> = async () => {
  await oneApi.post('session/logout');

  return null;
};

const logout: OneMutationService<null> = {
  id: 'logout',
  serviceId: SERVICE_ID,
  mutation: logoutMutator,
};

const loginService = {
  logout,
};

export default loginService;
